<template>
  <login v-if="!$auth.check()" />
</template>

<script>
import Login from 'views/Login'

export default {
  name: 'index',
  components: {
    Login
  },
  props: {
    isLoggedIn: {
      type: Boolean,
      default: true
    }
  },
  created() {
    if (this.$auth.check()) {
      this.$router.replace({ name: 'epgs' })
    }
  }
}
</script>
